// SERVICES
import EmployeeService from "@/services/employee.service";
import otherService from "@/services/other.service";

// STATE
const state = {
    loader: false,
    candidateData: null,
    UserPhotoByte: {},
    employee: null,
    employeeTestResult: {},
    passportDate: {},
    employeIdList: [],
    item: {},
    list: [],
    total: 0,
    cadr: false,

    // BY DEP ID
    totalByDep: 0,
    listByDep: [],
    selectedRow: null,
    tab: 'manage',
    page: 0,
    limit: 20,
    user: null,
    statusHistory: [],
    otherFiles: [],
    modalClose: true,

};

// GETTERS
const getters = {}

// ACTIONS
const actions = {
    async setOtherFile({ commit }, id) {
        try {
            let res = await otherService.getById(id);
            await commit('setOtherFile', res.data ? res.data : []);
        } catch (error) {
            await commit('setOtherFile', []);
        }
        // this.resume.name = response.data.photoName;
        // let file = window.URL.createObjectURL(response.data);
        // this.resume.urlResume = file
        // this.resume.byteOfResume = new File([response.data], "Image");
        // const fileReader = new FileReader();
        // fileReader.addEventListener("load", () => {
        //   this.resume.urlResume = fileReader.result;
        // });
        // fileReader.readAsDataURL(this.resume.byteOfResume);
    },

    async getStatusHistory({ commit }, id) {
        try {
            const res = await EmployeeService.getStatusHistory(id)
            await commit('setStatusHistory', res.data ? res.data : []);
        } catch (error) {
            await commit('setStatusHistory', []);
        }
    },
    async getEmployee({ commit }) {
        try {
            const res = await EmployeeService.getEmployee()
            await commit('setEmployee', res.data ? res.data : null);
        } catch (error) {
            await commit('setEmployee', null);
        }
    },
    async getEmployeePasportDate({ commit }, id) {
        await commit('setLoader', true)
        try {
            const res = await EmployeeService.getEmployeePassportDate(id)
            await commit('setpassportDate', res.data ? res.data : null);
            if (res.data) {
                await commit('setLoader', false)
            }
        } catch (error) {
            await commit('setpassportDate', null);
            await commit('setLoader', false)
        }
    },
    async getList({ commit }, params) {
        try {
            const res = await EmployeeService.getList(params)
            await commit('setListResponse', res);
        } catch (error) {
            await commit('setListResponse', error.response.data);
        }
    },
    async getUserPhoto({ commit }, id) {
        try {
            const res = await EmployeeService.getPhotoByte(id)
            await commit('setUserPhotoByte', res);
        } catch (error) {
            await commit('setUserPhotoByte', error.response.data);
        }
    },

    async getListByName({ commit }, params) {
        try {
            const res = await EmployeeService.getByDepIdAndByName(params)
            await commit('setResponseByDepId', res);
        } catch (error) {
            await commit('setResponseByDepId', error.response.data);
        }
    },
    async getById({ commit }, params) {
        try {
            const res = await EmployeeService.getById(params)
            await commit('setResponseById', res.data);
        } catch (error) {
            await commit('setResponseById', {});
        }
    },

    async getByDepId({ commit }, params) {
        try {
            const res = await EmployeeService.getByDepId(params)
            await commit('setResponseByDepId', res);
        } catch (error) {
            await commit('setResponseByDepId', error.response.data);
        }
    },
}

// MUTATIONS
const mutations = {
    setLoader(state, b) {
        state.loader = b
    },
    setAnswersModal(state, boolean) {
        state.modalClose = boolean
    },
    setStatusHistory(state, data) {
        state.statusHistory = data
    },
    setOtherFile(state, data) {
        state.otherFiles = data
    },
    setByLegal(state, obj) {
        state.byLegalId = obj
    },
    setEmployee(state, obj) {
        if (obj === "admin" || obj === "kadr") {
            state.user = obj
            state.employee = null
        } else {
            state.user = null
            state.employee = obj
        }
    },
    setCadr(state) {
        state.cadr = true
    },
    setpassportDate(state, obj) {
        state.passportDate = obj || {}
    },
    setPaginationPage(state, obj) {
        state.page = obj.page
        state.limit = obj.limit
    },
    setTab(state, tab) {
        state.tab = tab
    },
    setSelectedRow(state, payload) {
        state.selectedRow = payload
    },
    setResponseByDepId(state, payload) {
        state.listByDep = payload.data.list
        state.totalByDep = payload.data.total
    },
    setListResponse(state, payload) {
        state.list = payload.data.list
        state.total = payload.data.total
    },

    setResponseById(state, payload) {
        state.candidateData = payload
    },
    setResponseByEmployeeId(state, payload) {
        state.employeIdList = payload.data
    },
    setUserPhotoByte(state, payload) {
        state.UserPhotoByte = payload.data
    },
    setEmployeeTestResult(state, data) {
        state.employeeTestResult = data
    },

}

export const employee = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
